import React from 'react';

const Loader = () => {

    return (
        <div className="contenido">
            <div className="spinner">
            </div>
            <i className="fs-1 bi bi-camera" />
        </div>
    );
};

export default Loader;
